import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */ // MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
window.Components.Application.User.ProfilePreviewAffiliation = createReactClass({
  propTypes() {
    return {
      profile: PropTypes.object.isRequired
    };
  },
  render() {
    const avatar = /*#__PURE__*/_jsx(Components.Basic.Avatar, {
      profile: this.props.profile,
      className: "u-mr2x"
    });
    const header = this.props.profile.display_name;
    const subtext = /*#__PURE__*/_jsxs("div", {
      children: [" ", this.props.profile.university, " "]
    });
    return /*#__PURE__*/_jsx(Components.Compound.ImageHeaderSubtext, {
      image: avatar,
      header: header,
      subtext: subtext,
      url: this.props.profile.url,
      className: "u-m0x"
    });
  },
  displayName: "ProfilePreviewAffiliation"
});
window._jsx = _jsx;
window._jsxs = _jsxs;